import React from 'react';
import Header from './components/Header/Header.js';
import Footer from './components/Footer/Footer.js';
import Store from './components/Store/Store.js';

function App() {
  return (
    <div>
      <Header />
      <Store />
      <Footer />
    </div>
  );
}

export default App;